import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';

import Client from './client';
import { sessionStorageController } from './storages';

import type { UseQueryOptions } from '@tanstack/react-query';

import { parseApsStyles } from '#/guest-aps/utils/parse-aps-styles';

export const BULLETIN_KEY = 'bulletin_boards';

export type BulletinResponse = Awaited<
  ReturnType<typeof Client.fetchBulletinBoards>
>;

export type BulletinProps = {
  codes: string;
  partnerId?: string;
  distributor?: string;
};

export const useBulletinBoards = (
  { codes, partnerId, distributor }: BulletinProps,
  options: Omit<UseQueryOptions<BulletinResponse>, 'queryFn' | 'queryKey'> = {},
) => {
  const { data, status, error } = useQuery({
    queryKey: ['bulletin_boards', codes, partnerId, distributor],
    queryFn: () =>
      Client.fetchBulletinBoards({ codes, partnerId, distributor }),
    refetchInterval: false,
    enabled: !!codes,
    ...options,
  });

  const bulletinBoards = data?.data?.data ?? null;

  // Store asps partner template to session storage
  useEffect(() => {
    const apsPartnerTemplate = bulletinBoards?.aps_partner_template;
    if (apsPartnerTemplate == null) return;
    if (apsPartnerTemplate.length === 0) return;

    sessionStorageController.saveApsPartner(apsPartnerTemplate[0]);
  }, [bulletinBoards?.aps_partner_template]);

  const apsPartnerTemplate = bulletinBoards?.aps_partner_template?.[0];
  const { appBackgroundColor } = parseApsStyles(apsPartnerTemplate);
  const apsBackgroundStyles = apsPartnerTemplate
    ? { backgroundColor: appBackgroundColor }
    : { background: '#007AFF' };

  return {
    bulletinBoards,
    apsBackgroundStyles,
    apsPartnerTemplate,
    getBulletinBoardsStatus: status,
    getBulletinBoardsError: error,
  };
};
